var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassedHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.1641,
    r: 9.5,
    stroke: "#B6C700",
    strokeDasharray: "0.5 0.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90562 6.40083C5.50136 5.89521 4.81 5.8637 4.36142 6.33045C3.91284 6.7972 3.87692 7.58545 4.28118 8.09107L9.48466 14.5992C9.73742 14.9153 10.1024 15.0461 10.4501 14.9856C10.796 15.0435 11.1583 14.9124 11.4096 14.5981L14.7188 10.4592C15.1231 9.95362 15.0871 9.16536 14.6386 8.69861C14.19 8.23186 13.4986 8.26337 13.0944 8.76899L10.4467 12.0805L5.90562 6.40083Z",
    fill: "#B6C700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassedHistory);
export default __webpack_public_path__ + "static/media/passed_history.eb8715a624835b646a132d64aebafab4.svg";
export { ForwardRef as ReactComponent };